/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_5_LInputs */

const en_mk_proof_5_l = /** @type {(inputs: Mk_Proof_5_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian first, English fully available`)
};

const id_mk_proof_5_l = /** @type {(inputs: Mk_Proof_5_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesia sebagai bahasa utama, Inggris tersedia penuh`)
};

/**
* | output |
* | --- |
* | "Indonesian first, English fully available" |
*
* @param {Mk_Proof_5_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_5_l = /** @type {((inputs?: Mk_Proof_5_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_5_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_5_l(inputs)
	return en_mk_proof_5_l(inputs)
});